import httpRequestAdmin from "./httpRequest/httpRequestAdmin";

class JobPromotionService {
  getJobPromotions(params) {
    return httpRequestAdmin.get(process.env.REACT_APP_BACKEND_API_URL + "job/promotion/list", params);
  }

  updateJobPromotionStatus(body) {
    return httpRequestAdmin.put(process.env.REACT_APP_BACKEND_API_URL + "job/promotion/update/status", body);
  }
}

export default new JobPromotionService();
